import { ListItemIcon, ListItemText, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";

const useStyles = makeStyles(theme => ({
	menuItem: {
		"&:hover": {
			backgroundColor: theme.palette.primary.light
		}
	},
	menuItemLink: {
		color: "#222",
		textDecoration: "none",
		"&:hover": {
			color: "#222"
		}
	},
	destructiveMenuItem: {
		color: theme.palette.error.main,
		"&:hover": {
			backgroundColor: theme.palette.error.main,
			color: theme.palette.error.contrastText
		}
	}
}));

/**
 * This component represents a material menu item that contains a label and icon and a target.
 * This menu item can either link to a url or make a request to the backend depending on a flag (request)
 * Additional styling is provided for menu items that are destructive actions
 */
export default function StyledMenuItem(props) {
	const classes = useStyles();
	const { label, target, action, icon, destructive, noNewTab, handleClose } = props;

	const handleMenuItemRequestClick = () => {
		if (action) {
			action();
		}
		if (handleClose) {
			handleClose(label);
		}
	};

	const renderMenuItemRequest = () => {
		return (
			<MenuItem
				onClick={() => handleMenuItemRequestClick()}
				className={destructive ? classes.destructiveMenuItem : classes.menuItem}
			>
				<ListItemIcon>{icon}</ListItemIcon>
				<ListItemText primary={label} />
			</MenuItem>
		);
	};

	const renderMenuItemLink = () => {
		return (
			<a className={classes.menuItemLink} target={noNewTab ? "" : "_blank"} href={target}>
				<MenuItem
					onClick={() => handleMenuItemRequestClick()}
					className={destructive ? classes.destructiveMenuItem + classes.menuItem : classes.menuItem}
				>
					<ListItemIcon>{icon}</ListItemIcon>
					<ListItemText primary={label} />
				</MenuItem>
			</a>
		);
	};

	return target ? renderMenuItemLink() : renderMenuItemRequest();
}

StyledMenuItem.propTypes = {
	label: PropTypes.string,
	target: PropTypes.string,
	action: PropTypes.func,
	destructive: PropTypes.bool,
	noNewTab: PropTypes.bool,
	handleClose: PropTypes.func
};
